import React, { useMemo } from "react";

const RepairMRVTable = React.memo(
  ({ reportData = [], totalcount = 0, handlePrint, data }) => {
    const { storeName, repairMrvNo } = data?.document || {};

    // ✅ MOVE FUNCTION ABOVE useMemo
    const formatDateDMY = (date) => {
      if (!date) return "";
      const d = new Date(date);
      const day = String(d.getDate()).padStart(2, "0");
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const year = d.getFullYear();
      return `${day}/${month}/${year}`;
    };

    const tableRows = useMemo(() => {
      if (!reportData.length) {
        return (
          <tr>
            <td colSpan="14" className="text-center">
              No data available.
            </td>
          </tr>
        );
      }

      return reportData.map((item, index) => (
        <tr key={`${item.inventoryId}-${item.masterlistId}-${index}`}>
          <td>{index + 1}</td>
          <td className="scrollable-description">{storeName}</td>
          <td>{repairMrvNo}</td>

          {/* Inventory */}
          <td>{item.inventoryPartNo}</td>
          <td className="scrollable-description">{item.inventoryDescription}</td>
          <td>{item.inventoryUnit}</td>

          {/* Repair / MasterList */}
          <td>{item.masterlistPartNo}</td>
          <td className="scrollable-description">{item.masterlistDescription}</td>
          <td>{item.masterlistUnit}</td>

          {/* Qty */}
          <td>{item.qtyRequired}</td>
          <td>{item.approveQty}</td>
          <td>{item.qtyRecived}</td>

          {/* Status */}
          <td>
            <span
              className={`badge ${
                item.status === "recived" ? "bg-success" : "bg-warning"
              }`}
            >
              {item.status}
            </span>
          </td>

          {/* ✅ Date column (separate td) */}
          <td>{formatDateDMY(item.updatedAt)}</td>
        </tr>
      ));
    }, [reportData, storeName, repairMrvNo]);

    return (
      <div className="filter cm-content-box box-primary">
        <div className="content-title d-flex justify-content-between align-items-center">
          <div className="cpa">
            <i className="fa fa-wrench me-2"></i>
            Repair MRV Items
            <span className="badge bg-orange ms-2">{totalcount}</span>
          </div>

          {reportData.length > 0 && (
            <button className="btn btn-primary" onClick={handlePrint}>
              Print
            </button>
          )}
        </div>

        <div className="cm-content-body form excerpt">
          <div className="card-body">
            <div className="table-responsive">
              <table className="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Store</th>
                    <th>Repair MRV No</th>

                    <th>Inventory Part No</th>
                    <th>Inventory Description</th>
                    <th>Inventory Unit</th>

                    <th>Repair Part No</th>
                    <th>Repair Description</th>
                    <th>Repair Unit</th>

                    <th>Required Qty</th>
                    <th>Approved Qty</th>
                    <th>Received Qty</th>
                    <th>Status</th>
                    <th>Updated Date</th>
                  </tr>
                </thead>

                <tbody>{tableRows}</tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
);

export default RepairMRVTable;
